<template>
  <div class="legaldoc-v2-container" v-if="legalDoc">
    <Edit v-if="$store.state.modalStore.showLegalDoc" />
    <div class="legaldoc-v2-wrapper legaldoc-title">
      <div class="ld-name">Nama Dokumen</div>
      <div class="ld-ketersediaan">Ketersediaan</div>
      <div class="ld-active-date">Tgl Efektif</div>
      <div class="ld-end-date">Tgl Berakhir</div>
      <div class="ld-remainder">Sisa Hari Efektif</div>
      <div class="ld-number-doc">Nomor Dokumen</div>
      <div class="ld-file">Dokumen</div>
      <div class="ld-view"></div>
      <div class="ld-download"></div>
      <div class="ld-edit"></div>
    </div>
    <div
      class="legaldoc-v2-wrapper legaldoc-content"
      v-for="(list, index) in legalData"
      :key="index"
    >
      <div class="ld-name">
        <div>
          {{ list.desc ? list.desc : '-' }}
          <span v-if="list.required"
            >(
            <span :style="`color: ${list.required == 1 ? 'red' : 'blue'}`"
              >*</span
            >
            )</span
          >
        </div>
      </div>
      <div class="ld-ketersediaan">
        <div :style="`color: ${list.lampiran ? 'black' : 'red'}`">
          {{ list.lampiran ? 'Yes' : 'No' }}
        </div>
      </div>
      <div class="ld-active-date">
        <div>
          {{ list.tanggal_efektif ? formatDate(list.tanggal_efektif) : '-' }}
        </div>
      </div>
      <div class="ld-end-date">
        <div>
          {{ list.tanggal_berakhir ? formatDate(list.tanggal_berakhir) : '-' }}
        </div>
      </div>
      <div :class="`ld-remainder ${list.remainder < 0 ? `text-danger` : ''}`">
        <div>{{ reminder(list.reminder) }}</div>
      </div>
      <div class="ld-number-doc">
        <div>
          {{
            list.no_dokumen && list.no_dokumen != 'null' ? list.no_dokumen : '-'
          }}
        </div>
      </div>
      <div class="ld-file all-column">
        <div>{{ list.lampiran ? list.lampiran : '-' }}</div>
      </div>
      <div
        class="ld-download"
        @click="downloadDoc(list.lampiran)"
        v-if="list.lampiran"
      >
        <i class="fas fa-download"></i>
      </div>
      <div class="ld-edit" @click="showModal(list.id, list.desc)">
        <i class="far fa-edit" v-if="editingStatus && editingUser"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  components: {
    Edit: () => import('@/components/modal/legalDocument.vue'),
  },
  data() {
    return {
      showLegalDoc: true,
      legalData: [],
    }
  },
  computed: {
    legalDoc() {
      let legal = this.$store.state.level1.legalDoc
      if (legal && legal.length > 0) {
        let legalWithoutKTP =
          this.$store.state.level1.legalDoc &&
          this.$store.state.level1.legalDoc.filter(
            i => i.legal_document_id != 35 && i.legal_document_id != 36
          )
        let ktpKomisaris =
          this.$store.state.level1.legalDoc &&
          this.$store.state.level1.legalDoc.filter(
            i => i.legal_document_id == 36
          )
        let ktpDirektur =
          this.$store.state.level1.legalDoc &&
          this.$store.state.level1.legalDoc.filter(
            i => i.legal_document_id == 35
          )

        let newKtpKomisaris = []
        if (ktpKomisaris && ktpKomisaris.length > 0) {
          for (let i in ktpKomisaris) {
            if (i == 0) {
              newKtpKomisaris.push(ktpKomisaris[i])
            } else {
              newKtpKomisaris.push({
                ...ktpKomisaris[i],
                desc: 'KTP KOMISARIS',
              })
            }
          }
        }

        let newKtpDirektur = []
        if (ktpDirektur && ktpDirektur.length > 0) {
          for (let i in ktpDirektur) {
            if (i == 0) {
              newKtpDirektur.push(ktpDirektur[i])
            } else {
              newKtpDirektur.push({
                ...ktpDirektur[i],
                desc: 'KTP DIREKTUR',
              })
            }
          }
        }

        this.legalData = [
          ...legalWithoutKTP,
          ...newKtpKomisaris,
          ...newKtpDirektur,
        ]

        return true
      }

      return false
    },
    editingStatus() {
      return this.$get(
        this.$store,
        'state.editingStore.validation_revise.is_open',
        0
      )
    },
    editingUser() {
      return (
        this.$get(
          this.$store,
          'state.editingStore.validation_revise.user_id',
          ''
        ) == this.$get(this.$store, 'state.userid', 0)
      )
    },
  },
  methods: {
    showModal(id, name) {
      this.$store.commit('modalStore/SHOW_LEGAL_DOC')
      this.$store.dispatch('editStore/getLegalDocById', { id, name })
    },
    reminder(value) {
      if (value) {
        if (value < 0) {
          return `${value} (Expired)`
        } else {
          return value
        }
      }

      return '-'
    },
    changeEditMode(id) {
      this.$store.dispatch('setEditMode', id)
    },
    viewDoc(link) {
      window.open(`${api}/file/${link}`)
    },
    downloadDoc(link) {
      if (link) {
        let linkUrl = `${api}/file/${link}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
  },
}
</script>
